import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import {
  updateUserRole,
  updateUserFranchises,
  type UpdateUserRolePayload,
  type UpdateUserFranchisesPayload
} from '@/features/users/api'

export function useUpdateUserRoleMutation(options?: UseMutationOptions<any, unknown, UpdateUserRolePayload>) {
  return useMutation({
    mutationFn: updateUserRole,
    ...options
  })
}

export function useUpdateUserFranchisesMutation(options?: UseMutationOptions<any, unknown, UpdateUserFranchisesPayload>) {
  return useMutation({
    mutationFn: updateUserFranchises,
    ...options
  })
}
